<script setup lang="ts">
import { Button } from '@collector/shared-ui'
import { useEventClock } from '@desktop/views/Relation/Sports/composables'

interface Props {
  second: number
}

const props = defineProps<Props>()

// composables
const { addTimerSecond, updateEventClockTime } = useEventClock()

// methods
function updateEventClock(): void {
  addTimerSecond(props.second)
  updateEventClockTime()
}
</script>

<template>
  <Button
    class="text-neutral-dark-2 bg-neutral-light-10 border-neutral-light-5 hover:bg-neutral-light-5 active:border-neutral-light-0 active:bg-neutral-light-0 font-bold"
    size="sm"
    square
    @click="updateEventClock"
  >
    {{ `${second > 0 ? '+' : ''}${second}` }}
  </Button>
</template>
